module.exports = "/assets/images/right-arrow-small_9a2fdd.svg";